export default "__VITE_ASSET__ZHJnSlr3__"